import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { InformationBlock } from '@/components/ui';

import styles from './NotFoundPage.module.scss';

const NotFoundPage = ({ data, withTranslate }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const content = {
    title: withTranslate
      ? t(data?.title, { q: `"${router.query.q}"` })
      : data?.title,
    text: withTranslate ? t(data?.description) : data?.description,
    buttonText: data?.button_text,
  };

  return (
    <div className={styles.container}>
      <div className={'wrapper'}>
        <InformationBlock
          icon={
            <Image
              src={data?.icon}
              alt={withTranslate ? t(data?.title) : data?.title}
              title={withTranslate ? t(data?.title) : data?.title}
              width={180}
              height={75}
              loading='lazy'
            />
          }
          content={content}
        />
      </div>
    </div>
  );
};

export default NotFoundPage;
